import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loading-box" }
const _hoisted_2 = { style: {"margin":"0","margin-bottom":"5px","font-size":"0.7rem"} }
const _hoisted_3 = { style: {"text-align":"center"} }

import { ref } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'themeChangePopup',
  setup(__props, { expose: __expose }) {

const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const title = ref('')
const contactRef = ref()
const themeStore = useThemeStore()
const selectedTheme = ref(themeStore.themeIndex)

const themesList = ([{ themeIndex: 1, imgUrl: require('@/assets/theme/themeOne.png'), name: t('header.themeOne') }, { themeIndex: 2, imgUrl: require('@/assets/theme/themeTwo.png'), name: t('header.themeTwo') }])
const open = (value: string) => {
    show.value = true
    title.value = value
}


const close = () => {
    show.value = false
    contactRef.value.close()
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const openContactPopup = () => {
    contactRef.value.open()
}
const switchTheme = (index: number) => {
    selectedTheme.value = index
    themeStore.setThemeIndex(index)
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    round: "",
    position: "right",
    style: { padding: '1rem', top: '0', right: '2%', width: '60%'  }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_row, { gutter: "2" }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(themesList, (item, index) => {
            return _createVNode(_component_van_col, {
              span: "12",
              key: index,
              style: {"padding":"0 10px","text-align":"center"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_image, {
                  src: item.imgUrl,
                  width: "40",
                  height: "90"
                }, {
                  loading: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_van_loading, {
                        type: "spinner",
                        size: "20",
                        color: "#10b981"
                      })
                    ])
                  ]),
                  _: 2
                }, 1032, ["src"]),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(item.name)), 1)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_radio_group, {
          modelValue: selectedTheme.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTheme).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, { gutter: "2" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(themesList, (item, index) => {
                  return _createVNode(_component_van_col, {
                    span: "12",
                    key: index,
                    style: {"text-align":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_radio, {
                        name: item.themeIndex,
                        onClick: ($event: any) => (switchTheme(index + 1)),
                        style: {"display":"flex","justify-content":"center"},
                        "icon-size": "14px",
                        "checked-color": "#231e19"
                      }, null, 8, ["name", "onClick"])
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})